const state = {
};

export default {
  namespaced: true,
};